import React from 'react';
import { Loader2 } from 'lucide-react';
import type { RebuildProgress } from '@/types/rebuild';

interface RebuildProgressBannerProps {
  progress?: RebuildProgress;
  polling?: boolean;
}

export function RebuildProgressBanner({ progress, polling }: RebuildProgressBannerProps) {
  if (!polling && !progress?.current_metric) return null;

  const done = progress?.completed_recommendations ?? 0;
  const total = progress?.total_recommendations ?? 0;
  const pct = total > 0 ? Math.round((done / total) * 100) : 0;

  return (
    <div className="flex items-center gap-3 rounded-lg border border-amber-500/30 bg-amber-500/10 px-4 py-3 text-amber-200/90 text-sm font-sans">
      <Loader2 className="h-4 w-4 animate-spin shrink-0" />
      <div>
        <p>Applying recommendations… {done}/{total} ({pct}%)</p>
        {progress?.current_metric && (
          <p className="text-xs text-amber-200/60 mt-0.5">Current: {progress.current_metric}</p>
        )}
      </div>
    </div>
  );
}
